import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./config/language/en.json";
import ja from "./config/language/ja.json";
import kr from "./config/language/kr.json";
import { authLocales } from "./modules/auth/locales";
import { landingLocales } from "./modules/sites/locales";
import { settingsLocales } from "./modules/settings/locales";
import { walletLocales } from "./modules/wallet/locales";
import { talentRegisterLocales } from "./modules/talent/register/locales";
import { hallLocales } from "./modules/hall/locales";
import { tnLocales } from "./modules/tn/locales";
import { talentDeckLocales } from "./modules/charm/locales";
import { sidebarLocales } from "./shared/components/sidebar/locales";
import { charmLocales } from "./modules/charm/locales";
import { headerLocales } from "./shared/components/header/locales";
import { notificationLocales } from "./modules/notification/locales";
import { inboxLocales } from "./modules/inbox/locales";
import { collectionLocales } from "./cards/collection-card/locales";
import { taascardLocales, taascardValidationLocales } from "./cards/locales";
import { organizationLocales } from "./modules/organization/locales";

const storedLang = localStorage.getItem("lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: en,
      auth: authLocales.en,
      landing: landingLocales.en,
      settings: settingsLocales.en,
      wallet: walletLocales.en,
      talentRegister: talentRegisterLocales.en,
      hall: hallLocales.en,
      tn: tnLocales.en,
      talentDeck: talentDeckLocales.en,
      charm: charmLocales.charmEn,
      sidebar: sidebarLocales.en,
      header: headerLocales.en,
      notification: notificationLocales.en,
      inbox: inboxLocales.en,
      collection: collectionLocales.en,
      taascard: taascardLocales.en,
      taascardValidation: taascardValidationLocales.validationEn,
      organization: organizationLocales.en,
    },
    ja: {
      common: ja,
      auth: authLocales.ja,
      landing: landingLocales.ja,
      settings: settingsLocales.ja,
      wallet: walletLocales.ja,
      talentRegister: talentRegisterLocales.ja,
      hall: hallLocales.ja,
      tn: tnLocales.ja,
      talentDeck: talentDeckLocales.ja,
      charm: charmLocales.charmJa,
      sidebar: sidebarLocales.ja,
      header: headerLocales.ja,
      notification: notificationLocales.ja,
      inbox: inboxLocales.ja,
      collection: collectionLocales.ja,
      taascard: taascardLocales.ja,
      taascardValidation: taascardValidationLocales.validationJa,
      organization: organizationLocales.ja,
    },
    kr: {
      common: kr,
      auth: authLocales.kr,
      landing: landingLocales.kr,
      settings: settingsLocales.kr,
      wallet: walletLocales.kr,
      talentRegister: talentRegisterLocales.kr,
      hall: hallLocales.kr,
      tn: tnLocales.kr,
      talentDeck: talentDeckLocales.kr,
      charm: charmLocales.charmKr,
      sidebar: sidebarLocales.kr,
      header: headerLocales.kr,
      notification: notificationLocales.kr,
      inbox: inboxLocales.kr,
      collection: collectionLocales.kr,
      taascard: taascardLocales.kr,
      taascardValidation: taascardValidationLocales.validationKr,
      organization: organizationLocales.kr,
    },
  },
  lng: storedLang,
  fallbackLng: "en",
  ns: ["common", "auth", "organization", "landing"],
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export default i18n;
